module.exports = __webpack_public_path__ + "logo.png?c2aa4bfbe45c9e04ddb85b43d22921a1";